import {
    asyncListWithSkipTakeCreate,
    asyncListWithPaginationCursorCreate,
    AsyncListWithPaginationCursor,
    cachedValueCreateWithParamsV2,
    Evaluable,
    evaluateWhenFunction,
    hashFunctionCreate,
    stringReplaceEmptyOrWhiteSpaceValue,
    valueConvertWhenNotNullable
} from '@wix/devzai-utils-common';
import type {DoppeDtoStoreProduct, DoppeDtoStoreProductType} from '../../../client-server-common/types/doppe-dto-store-product';
import type {IDoppeViewerApi} from '../../../client-server-common/api/doppe-viewer-api';

export function doppeViewerAsyncListFactoryProducts(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryProducts.Params>({
            search: hashFunctionCreate(),
            productType: hashFunctionCreate(),
        }),
        paramsNormalizationFunction: params => ({
            ...params,
            search: valueConvertWhenNotNullable(params.search, s =>
                stringReplaceEmptyOrWhiteSpaceValue(s, undefined)
            )
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithSkipTakeCreate<DoppeDtoStoreProduct>({
                fetchFunction: async (skip, take) => {
                    return viewerApiClient.getStoreProducts({
                        skip: skip,
                        take: take,
                        search: params.search,
                        productType: params.productType,
                    });
                },
                defaultTake: 30,
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryProducts {
    export interface Params {
        search?: string;
        productType?: DoppeDtoStoreProductType;
    }
}

export function doppeViewerAsyncListFactoryProductsByCategory(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryProductsByCategory.Params>({
            categorySlug: hashFunctionCreate(),
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithPaginationCursorCreate<DoppeDtoStoreProduct, string>({
                fetchFunction: async (fetchContext: AsyncListWithPaginationCursor.FetchContext<string>) => {
                    const result = await viewerApiClient.getStoreProductsByCategorySlug({
                        categorySlug: params.categorySlug,
                        cursor: fetchContext.isInitialFetch ? undefined : fetchContext.cursor,
                        limit: 30,
                    });

                    return {
                        results: result.results,
                        cursor: result.cursor,
                        totalCount: result.totalCount,
                    };
                },
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryProductsByCategory {
    export interface Params {
        categorySlug: string;
    }
}
